__turbopack_context__.v({
  "close": "toast-module__x-HxCa__close",
  "content": "toast-module__x-HxCa__content",
  "error": "toast-module__x-HxCa__error",
  "icon": "toast-module__x-HxCa__icon",
  "info": "toast-module__x-HxCa__info",
  "subtitle": "toast-module__x-HxCa__subtitle",
  "success": "toast-module__x-HxCa__success",
  "title": "toast-module__x-HxCa__title",
  "toast": "toast-module__x-HxCa__toast",
  "toast-enter": "toast-module__x-HxCa__toast-enter",
  "warning": "toast-module__x-HxCa__warning",
});
